__webpack_require__.p = "/e-commerce_with_reduxTypeScript/";